module.exports = __webpack_public_path__ + "assets/img/9f84d59ede2272cba67cf710b0e80fd5.png";